<template>
  <nav
    class="navbar navbar-expand-lg nav-container"
    :class="{ header_dark: theme === 'dark', header_light: theme === 'light' }"
  >
    <div class="container-fluid">
      <!-- Botão hambúrguer -->
      <button
        class="navbar-toggler icon-navgator-mob"
        type="button"
        data-bs-toggle="navbar-toggler"
        data-bs-target="#navbarNavDarkDropdown"
        aria-controls="navbarNavDarkDropdown"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="toggleOffcanvas"
      >
        <span class="navbar-toggler-icon"><i class="bi bi-list"></i></span>
      </button>
      <a class="navbar-brand d-none d-lg-block">
        <img src="../../assets/logo.png" alt="Deal Desk" class="logo" />
      </a>

      <div
        class="collapse navbar-collapse d-none d-lg-block mb-3"
        id="navbarNavDarkDropdown"
      >
        <ul class="navbar-nav">
          <li id="rf_parametros" class="nav-item dropdown">
            <button
              class="btn btn-menu dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="true"
            >
              Parâmetros
            </button>
            <ul
              class="dropdown-menu dropdown-menu-dark"
              data-bs-auto-close="outside"
            >
              <li class="nav-item m-1">
                <a href="/admin/cortesias" class="nav-link p-2"> Cortesias </a>
              </li>
              <li class="nav-item m-1">
                <a href="/admin/clientes" class="nav-link p-2"> Clientes </a>
              </li>
              <li class="nav-item m-1">
                <a href="/admin/empresas" class="nav-link p-2"> Empresas </a>
              </li>
              <li class="nav-item m-1">
                <a href="/admin/midias" class="nav-link p-2"> Mídias </a>
              </li>
              <li class="nav-item m-1">
                <a href="/admin/usuarios" class="nav-link p-2"> Usuários </a>
              </li>
              <li class="nav-item m-1">
                <hr class="dropdown-divider" />
              </li>
              <li class="nav-item m-1">
                <a href="/admin/bancos" class="nav-link p-2"> Bancos </a>
              </li>
              <li class="nav-item m-1">
                <a href="/admin/custos_variaveis" class="nav-link p-2">
                  Custos Variáveis
                </a>
              </li>
              <li class="nav-item m-1">
                <a href="/admin/taxas" class="nav-link p-2"> Taxas </a>
              </li>
              <li>
                <hr class="dropdown-divider" />
              </li>
              <li class="nav-item m-1">
                <a href="/admin/combustiveis" class="nav-link p-2">
                  Combustíveis
                </a>
              </li>
              <li class="nav-item m-1">
                <a href="/admin/cor_veiculos" class="nav-link p-2">
                  Cor Veículo
                </a>
              </li>
              <li class="nav-item m-1">
                <a href="/admin/familia_veiculos" class="nav-link p-2">
                  Família Veículos
                </a>
              </li>
              <li class="nav-item m-1">
                <a href="/admin/marca_veiculos" class="nav-link p-2">
                  Marca Veículos
                </a>
              </li>
              <li class="nav-item m-1">
                <a href="/admin/modelo_veiculos" class="nav-link p-2">
                  Modelo Veículos
                </a>
              </li>
              <li class="nav-item m-1">
                <a href="/admin/estoque_veiculos" class="nav-link p-2">
                  Sincronizar Estoque
                </a>
              </li>
              <!-- <li class="nav-item m-1">
                <a
                  href="/admin/tipo_pagamento"
                  class="nav-link p-2"
                >
                  Tipo Pagamento</a
                >
              </li> -->
              <!-- <li class="nav-item">
                <a
                  @click="setActive('parametros')"
                  href="/admin/veiculos_vendido_estoque"
                  class="nav-link p-2"
                >
                  Aguardando Faturamento
                </a>
              </li> -->
              <!-- <li class="nav-item">
                <a
                  @click="setActive('parametros')"
                  href="/admin/veiculos_reserva"
                  class="nav-link p-2"
                >
                  Veículos com Reserva
                </a>
              </li> -->
              <!-- <li class="nav-item"><a href="/admin/situacao_veiculo" class="nav-link p-2"> Situação Veículo </a></li> -->
            </ul>
          </li>

          <li id="rf_atendimentos" class="nav-item dropdown">
            <button
              class="btn btn-menu dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="true"
            >
              Atendimento
            </button>
            <ul class="dropdown-menu dropdown-menu-dark">
              <li class="nav-item">
                <a href="/atendimento/dashboard" class="nav-link p-2">
                  Dashboard
                </a>
              </li>
              <li class="nav-item">
                <a href="/atendimento/proposta" class="nav-link p-2">
                  Novo Atendimento
                </a>
              </li>
            </ul>
          </li>
          <li id="rf_gerenciamento" class="nav-item dropdown">
            <button
              class="btn btn-menu dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="true"
            >
              Gerenciamento
            </button>
            <ul class="dropdown-menu dropdown-menu-dark">
              <!-- <li class="nav-item">
                <a

                  href="/desk/index"
                  class="nav-link p-2"
                >
                  Desk
                </a>
              </li> -->
              <li class="nav-item">
                <a href="/desk/indexGerente" class="nav-link p-2">
                  Desk Gerente
                </a>
              </li>
              <li class="nav-item">
                <a href="/desk/reabrirProposta" class="nav-link p-2">
                  Reabrir Atendimentos
                </a>
              </li>
            </ul>
          </li>
          <li id="rf_relatorios" class="nav-item dropdown">
            <button
              :class="{
                btn: true,
                'btn-menu': true,
                'btn-active': active === 'relatorios',
              }"
              class="dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="true"
            >
              Relatórios BI
            </button>
            <ul class="dropdown-menu dropdown-menu-dark">
              <li class="nav-item">
                <a href="/desk/veiculosAvaliacao" class="nav-link p-2">
                  Avaliação
                </a>
              </li>
              <li class="nav-item">
                <a href="/relatorioBi/index" class="nav-link p-2">
                  BI
                </a>
              </li>
              <li class="nav-item">
                <a href="/desk/relatorio" class="nav-link p-2">
                  Fluxo de Lojas
                </a>
              </li>
              <li class="nav-item">
                <a href="/desk/situacaoGeral" class="nav-link p-2">
                  Situação Geral
                </a>
              </li>

            </ul>
          </li>
        </ul>
      </div>

      <div id="rf_profile" v-if="currentUser" class="d-none d-lg-block">
        <ul class="nav nav-item justify-content-end">
          <!-- Botão 1 -->
          <!-- <li class="nav-item dropdown">
            <button
              class="dropdown-toggle-icon"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="bi bi-brightness-high"></i>
            </button>
          </li> -->
          <!-- Botão 2 -->
          <li class="nav-item dropdown">
            <button
              class="dropdown-toggle-icon"
              data-bs-toggle="dropdown"
              aria-expanded="true"
            >
              <i class="bi bi-shop"></i>
            </button>
            <ul
              class="dropdown-menu dropdown-menu-dark dropdown-menu-end rf-dropdown-menu rf-profile-dropdown-menu"
            >
              <!-- Conteúdo do dropdown -->
              <li class="nav-item">
                <router-link to="" class="nav-link">
                  <font-awesome-icon icon="user" />
                  {{ empresaPrincipal.nome }}
                </router-link>
              </li>
            </ul>
          </li>
          <!-- Botão 3 -->
          <li class="nav-item dropdown">
            <button
              class="dropdown-toggle-icon"
              data-bs-toggle="dropdown"
              aria-expanded="true"
            >
              <i class="bi bi-person-circle"></i>
            </button>
            <ul
              class="dropdown-menu dropdown-menu-dark dropdown-menu-end rf-dropdown-menu rf-profile-dropdown-menu"
            >
              <!-- Conteúdo do dropdown -->
              <li class="nav-item">
                <router-link to="/profile" class="nav-link">
                  <div class="rf-profile-content">
                    <font-awesome-icon icon="user" style="margin-right: 5px" />
                    {{ currentUser.username }}
                  </div>
                </router-link>
              </li>
              <li class="nav-item">
                <a class="nav-link" @click.prevent="logOut">
                  <font-awesome-icon icon="sign-out-alt" /> Sair
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <!-- Offcanvas (menu lateral) -->
      <div
        class="offcanvas offcanvas-start d-lg-none"
        tabindex="-1"
        :class="{ show: showOffcanvas }"
        style="visibility: visible; overflow-y: auto"
        aria-modal="true"
        role="dialog"
      >
        <div class="offcanvas-header border-bottom py-2">
          <h5 class="offcanvas-title" id="bdSidebarOffcanvasLabel">
            <span style="vertical-align: inherit"
              ><span style="vertical-align: inherit"
                ><a class="navbar-brand">
                  <img
                    src="../../assets/logo.png"
                    alt="Deal Desk"
                    class="logo"
                    style="height: 30px"
                  /> </a></span
            ></span>
          </h5>
          <button
            type="button"
            class="btn-close title-text-logout"
            @click="closeOffcanvas"
          ></button>
        </div>
        <div class="position-sticky pt-2 sidebar">
          <!--Parâmetros-->
          <ul class="nav flex-column menu-border-mobile mb-1">
            <li class="nav-item dropdown title-mob">
              <button
                class="title-text-mob btn w-100 text-start d-flex align-items-center py-2"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collParametro"
                aria-expanded="false"
                aria-controls="collapseWidthExample"
                style="font-size: 0.9rem; font-weight: 500"
              >
                <i
                  class="bi bi-sliders me-3"
                  style="font-size: 0.9rem; width: 20px; text-align: center"
                ></i>
                <span style="flex: 1">Parâmetros</span>
                <i class="bi bi-chevron-down" style="font-size: 0.8rem"></i>
              </button>
            </li>
          </ul>
          <div
            class="collapse collapse-horizontal"
            id="collParametro"
            data-bs-parent=".sidebar"
          >
            <ul class="nav flex-column border-top py-1">
              <li class="nav-item m-1">
                <a
                  href="/admin/cortesias"
                  class="nav-link p-1 d-flex align-items-center"
                  style="font-size: 0.85rem"
                >
                  <i
                    class="bi bi-tools icon-text-logout me-3"
                    style="font-size: 0.85rem; width: 20px; text-align: center"
                  ></i>
                  <span>Cortesias</span>
                </a>
              </li>
              <li class="nav-item m-1">
                <a
                  href="/admin/clientes"
                  class="nav-link p-1 d-flex align-items-center"
                  style="font-size: 0.85rem"
                >
                  <i
                    class="bi bi-people-fill icon-text-logout me-3"
                    style="font-size: 0.85rem; width: 20px; text-align: center"
                  ></i>
                  <span>Clientes</span>
                </a>
              </li>
              <li class="nav-item m-1">
                <a
                  href="/admin/empresas"
                  class="nav-link p-1 d-flex align-items-center"
                  style="font-size: 0.85rem"
                >
                  <i
                    class="bi bi-building icon-text-logout me-3"
                    style="font-size: 0.85rem; width: 20px; text-align: center"
                  ></i>
                  <span>Empresas</span>
                </a>
              </li>
              <li class="nav-item m-1">
                <a
                  href="/admin/midias"
                  class="nav-link p-1 d-flex align-items-center"
                  style="font-size: 0.85rem"
                >
                  <i
                    class="bi bi-megaphone icon-text-logout me-3"
                    style="font-size: 0.85rem; width: 20px; text-align: center"
                  ></i>
                  <span>Mídias</span>
                </a>
              </li>
              <li class="nav-item m-1">
                <a
                  href="/admin/usuarios"
                  class="nav-link p-1 d-flex align-items-center"
                  style="font-size: 0.85rem"
                >
                  <i
                    class="bi bi-person-badge icon-text-logout me-3"
                    style="font-size: 0.85rem; width: 20px; text-align: center"
                  ></i>
                  <span>Usuários</span>
                </a>
              </li>
              <li class="nav-item m-1">
                <a
                  href="/admin/bancos"
                  class="nav-link p-1 d-flex align-items-center"
                  style="font-size: 0.85rem"
                >
                  <i
                    class="bi bi-bank2 icon-text-logout me-3"
                    style="font-size: 0.85rem; width: 20px; text-align: center"
                  ></i>
                  <span>Bancos</span>
                </a>
              </li>
              <li class="nav-item m-1">
                <a
                  href="/admin/taxas"
                  class="nav-link p-1 d-flex align-items-center"
                  style="font-size: 0.85rem"
                >
                  <i
                    class="bi bi-percent icon-text-logout me-3"
                    style="font-size: 0.85rem; width: 20px; text-align: center"
                  ></i>
                  <span>Taxas</span>
                </a>
              </li>
              <li class="nav-item m-1">
                <a
                  href="/admin/combustiveis"
                  class="nav-link p-1 d-flex align-items-center"
                  style="font-size: 0.85rem"
                >
                  <i
                    class="bi bi-fuel-pump icon-text-logout me-3"
                    style="font-size: 0.85rem; width: 20px; text-align: center"
                  ></i>
                  <span>Combustíveis</span>
                </a>
              </li>
              <li class="nav-item m-1">
                <a
                  href="/admin/cor_veiculos"
                  class="nav-link p-1 d-flex align-items-center"
                  style="font-size: 0.85rem"
                >
                  <i
                    class="bi bi-palette icon-text-logout me-3"
                    style="font-size: 0.85rem; width: 20px; text-align: center"
                  ></i>
                  <span>Cor Veículo</span>
                </a>
              </li>
              <li class="nav-item m-1">
                <a
                  href="/admin/familia_veiculos"
                  class="nav-link p-1 d-flex align-items-center"
                  style="font-size: 0.85rem"
                >
                  <i
                    class="bi bi-car-front-fill icon-text-logout me-3"
                    style="font-size: 0.85rem; width: 20px; text-align: center"
                  ></i>
                  <span>Família Veículos</span>
                </a>
              </li>
              <li class="nav-item m-1">
                <a
                  href="/admin/marca_veiculos"
                  class="nav-link p-1 d-flex align-items-center"
                  style="font-size: 0.85rem"
                >
                  <i
                    class="bi bi-tag-fill icon-text-logout me-3"
                    style="font-size: 0.85rem; width: 20px; text-align: center"
                  ></i>
                  <span>Marca Veículos</span>
                </a>
              </li>
              <li class="nav-item m-1">
                <a
                  href="/admin/modelo_veiculos"
                  class="nav-link p-1 d-flex align-items-center"
                  style="font-size: 0.85rem"
                >
                  <i
                    class="bi bi-card-checklist icon-text-logout me-3"
                    style="font-size: 0.85rem; width: 20px; text-align: center"
                  ></i>
                  <span>Modelo Veículos</span>
                </a>
              </li>
              <li class="nav-item m-1">
                <a
                  href="/admin/estoque_veiculos"
                  class="nav-link p-1 d-flex align-items-center"
                  style="font-size: 0.85rem"
                >
                  <i
                    class="bi bi-arrow-repeat icon-text-logout me-3"
                    style="font-size: 0.85rem; width: 20px; text-align: center"
                  ></i>
                  <span>Sincronizar Estoque</span>
                </a>
              </li>
            </ul>
          </div>

          <!--Atendimento-->
          <ul class="nav flex-column menu-border-mobile mb-1">
            <li class="nav-item dropdown title-mob">
              <button
                class="title-text-mob btn w-100 text-start d-flex align-items-center py-2"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collAtendimento"
                aria-expanded="false"
                aria-controls="collapseWidthExample"
                style="font-size: 0.9rem; font-weight: 500"
              >
                <i
                  class="bi bi-headset me-3"
                  style="font-size: 0.9rem; width: 20px; text-align: center"
                ></i>
                <span style="flex: 1">Atendimento</span>
                <i class="bi bi-chevron-down" style="font-size: 0.8rem"></i>
              </button>
            </li>
          </ul>
          <div
            class="collapse collapse-horizontal"
            id="collAtendimento"
            data-bs-parent=".sidebar"
          >
            <ul class="nav flex-column border-top py-1">
              <li class="nav-item m-1">
                <a
                  href="/atendimento/dashboard"
                  class="nav-link p-1 d-flex align-items-center"
                  style="font-size: 0.85rem"
                >
                  <i
                    class="bi bi-speedometer2 icon-text-logout me-3"
                    style="font-size: 0.85rem; width: 20px; text-align: center"
                  ></i>
                  <span>Dashboard</span>
                </a>
              </li>
              <li class="nav-item m-1">
                <a
                  href="/atendimento/proposta"
                  class="nav-link p-1 d-flex align-items-center"
                  style="font-size: 0.85rem"
                >
                  <i
                    class="bi bi-plus-circle-fill icon-text-logout me-3"
                    style="font-size: 0.85rem; width: 20px; text-align: center"
                  ></i>
                  <span>Novo Atendimento</span>
                </a>
              </li>
            </ul>
          </div>

          <!--Gerenciamento-->
          <ul class="nav flex-column menu-border-mobile mb-1">
            <li class="nav-item dropdown title-mob">
              <button
                class="title-text-mob btn w-100 text-start d-flex align-items-center py-2"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collGerenciamento"
                aria-expanded="false"
                aria-controls="collapseWidthExample"
                style="font-size: 0.9rem; font-weight: 500"
              >
                <i
                  class="bi bi-clipboard-data me-3"
                  style="font-size: 0.9rem; width: 20px; text-align: center"
                ></i>
                <span style="flex: 1">Gerenciamento</span>
                <i class="bi bi-chevron-down" style="font-size: 0.8rem"></i>
              </button>
            </li>
          </ul>
          <div
            class="collapse collapse-horizontal"
            id="collGerenciamento"
            data-bs-parent=".sidebar"
          >
            <ul class="nav flex-column border-top py-1">
              <li class="nav-item m-1">
                <a
                  href="/desk/indexGerente"
                  class="nav-link p-1 d-flex align-items-center"
                  style="font-size: 0.85rem"
                >
                  <i
                    class="bi bi-columns-gap icon-text-logout me-3"
                    style="font-size: 0.85rem; width: 20px; text-align: center"
                  ></i>
                  <span>Desk Gerente</span>
                </a>
              </li>
              <li class="nav-item m-1">
                <a
                  href="/desk/reabrirProposta"
                  class="nav-link p-1 d-flex align-items-center"
                  style="font-size: 0.85rem"
                >
                  <i
                    class="bi bi-arrow-counterclockwise icon-text-logout me-3"
                    style="font-size: 0.85rem; width: 20px; text-align: center"
                  ></i>
                  <span>Reabrir Atendimentos</span>
                </a>
              </li>
            </ul>
          </div>

          <!--Relatório Desk-->
          <ul class="nav flex-column menu-border-mobile mb-1">
            <li class="nav-item dropdown title-mob">
              <button
                class="title-text-mob btn w-100 text-start d-flex align-items-center py-2"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collRelDesk"
                aria-expanded="false"
                aria-controls="collapseWidthExample"
                style="font-size: 0.9rem; font-weight: 500"
              >
                <i
                  class="bi bi-file-earmark-bar-graph me-3"
                  style="font-size: 0.9rem; width: 20px; text-align: center"
                ></i>
                <span style="flex: 1">Relatórios BI</span>
                <i class="bi bi-chevron-down" style="font-size: 0.8rem"></i>
              </button>
            </li>
          </ul>
          <div
            class="collapse collapse-horizontal"
            id="collRelDesk"
            data-bs-parent=".sidebar"
          >
            <ul class="nav flex-column border-top py-1">
              <li class="nav-item m-1">
                <a
                  href="/desk/relatorio"
                  class="nav-link p-1 d-flex align-items-center"
                  style="font-size: 0.85rem"
                >
                  <i
                    class="bi bi-shop-window icon-text-logout me-3"
                    style="font-size: 0.85rem; width: 20px; text-align: center"
                  ></i>
                  <span>Fluxo de Lojas</span>
                </a>
              </li>
              <li class="nav-item m-1">
                <a
                  href="/desk/situacaoGeral"
                  class="nav-link p-1 d-flex align-items-center"
                  style="font-size: 0.85rem"
                >
                  <i
                    class="bi bi-clipboard2-pulse icon-text-logout me-3"
                    style="font-size: 0.85rem; width: 20px; text-align: center"
                  ></i>
                  <span>Situação Geral</span>
                </a>
              </li>
            </ul>
          </div>

          <div class="mt-4 pt-3 border-top">
            <div id="rf_profile" v-if="currentUser">
              <ul class="nav flex-column">
                <li class="nav-item">
                  <a class="nav-link d-flex align-items-center py-1">
                    <i
                      class="bi bi-shop icon-text-logout me-3"
                      style="
                        font-size: 0.85rem;
                        width: 20px;
                        text-align: center;
                      "
                    ></i>
                    <span
                      class="title-text-logout"
                      style="font-size: 0.85rem"
                      >{{ empresaPrincipal.nome }}</span
                    >
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link d-flex align-items-center py-1"
                    @click.prevent="logOut"
                  >
                    <i
                      class="bi bi-box-arrow-right icon-text-logout me-3"
                      style="
                        font-size: 0.85rem;
                        width: 20px;
                        text-align: center;
                      "
                    ></i>
                    <span class="title-text-logout" style="font-size: 0.85rem"
                      >Sair</span
                    >
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="showOffcanvas"
      class="offcanvas-backdrop fade show"
      @click="closeOffcanvas"
    ></div>
  </nav>
</template>
<script>
import userService from "../../services/user.service";
import TokenService from "../../services/token.service";
import jwt_decode from "jwt-decode";

export default {
  data() {
    return {
      showOffcanvas: false,
      selectedEmpresa: null,
      optionsEmpresa: [],
      empresaPrincipal: { id: null, nome: "" },
      usuario: [],
      dados_user: "",
      company_id: "",
      darkMode: false,
      end_logo: "@/assets/logo.png",
      theme: "light",
      active: null,
    };
  },
  mounted() {
    //this.retrieveEmpresas();
    this.getToken();
    // let darkModeFromStorage = localStorage.getItem('darkMode');
    // this.darkMode = darkModeFromStorage ? darkModeFromStorage === 'true' : false;
    // document.getElementById('theme-style').href = this.darkMode ? '../../assets/styles/light-theme.css' : '../../assets/styles/dark-theme.css';
    // this.logo()
  },
  actions: {
    async logout({ commit }) {
      try {
        // 1. Chama o back-end para atualizar o status
        await this.$axios.post("/api/auth/logout");

        // 2. Limpa os dados locais
        commit("REMOVE_TOKEN");
        commit("CLEAR_USER_DATA");

        // 3. Redireciona
        this.$router.push("/login");
      } catch (error) {
        console.error("Erro durante logout:", error);
        // Fallback: Limpa os dados mesmo com erro no back-end
        commit("REMOVE_TOKEN");
        commit("CLEAR_USER_DATA");
        this.$router.push("/login");
      }
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },

    showAdminBoard() {
      if (this.currentUser && this.currentUser["funcoes"]) {
        return this.currentUser["funcoes"].includes("Função: ADMINISTRADOR");
      }

      return false;
    },
    showModeratorBoard() {
      if (this.currentUser && this.currentUser["funcoes"]) {
        return this.currentUser["funcoes"].includes("Função: GERENTE");
      }

      return false;
    },
    showAtendimentoBoard() {
      if (this.currentUser && this.currentUser["funcoes"]) {
        return this.currentUser["funcoes"].includes("Função: RECEPÇÃO");
      }

      return false;
    },
  },
  created() {
    // Recuperar o estado do botão ativo do armazenamento local ao carregar a página
    this.active = localStorage.getItem("activeMenu") || null;
  },
  methods: {
    toggleOffcanvas() {
      this.showOffcanvas = !this.showOffcanvas;
    },
    closeOffcanvas() {
      this.showOffcanvas = false;
    },
    toggleTheme() {
      this.darkMode = !this.darkMode;
      document.getElementById("theme-style").href = this.darkMode
        ? "../../assets/styles/light-theme.css"
        : "../../assets/styles/dark-theme.css";
      console.log(this.darkMode);
      localStorage.setItem("darkMode", this.darkMode.toString());
      this.logo();
    },
    logo() {
      if (this.darkMode) {
        this.end_logo = require("@/assets/logo.png");
        this.theme = "light";
        console.log("Usar logo claro");
      } else {
        console.log("Usar logo Escuro");
        this.theme = "dark";
        this.end_logo = require("@/assets/logo_branco.png");
      }
    },
    getToken() {
      const accessToken = TokenService.getLocalAccessToken();

      // Obter o token de atualização (refresh token)
      TokenService.getLocalRefreshToken();

      // Obter o usuário completo (incluindo os tokens) se necessário
      TokenService.getUser();

      const decodedToken = jwt_decode(accessToken);

      this.company_id = decodedToken.company;
      this.retrieveEmpresas(this.company_id);
    },
    retrieveEmpresas(company_id) {
      userService
        .getEmpresaId(company_id)
        .then((response) => {
          const dados = response.data;
          console.log(this.currentUser);
          this.empresaPrincipal = { id: dados.id, nome: dados.nome };
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.abrir_modal = true;
            this.msg = error.response.data.message;
          }
        });

      // userService.getUserId(this.currentUser.id).then((response) =>{
      //   const dados = response.data;
      //   console.log(dados);
      //   const empresa_id = response.data.empresa_id;
      //   this.empresa = dados.empresa.find(empresa => empresa.id === empresa_id);

      //   this.empresaPrincipal = {id:this.empresa.id, nome: this.empresa.nome}

      // })

      // this.selectedEmpresa = this.currentUser.empresas[0].nome,
      // this.optionsEmpresa = this.currentUser.empresas
      // this.empresaPrincipal = {id:this.currentUser.empresas[0].id, nome: this.currentUser.empresas[0].nome}
      //this.empresaPrincipal = {id:this.empresa.id, nome: this.empresa.nome}
    },

    logOut() {
      const userId = this.$store.state.auth.user?.id; // Ou de onde você obtém o ID
      this.$store.dispatch("auth/logout", { userId }).then(() => {
        this.$router.push("/login");
      });
    },
  },
};
</script>
